import { Chip, styled, Typography } from '@mui/material';
import { AvailabilityType } from 'api/services/availability/availability-service.schema';
import { useTranslation } from 'react-i18next';
import { getColorForAvailabilityType } from '../helpers/get-color-for-availability-type';

export const AvailabilityTypeChip = ({ type }: { type: AvailabilityType }) => {
  const { t } = useTranslation('all-platforms-common');

  let label: string;
  switch (type) {
    case 'available':
      label = t('availability_page.worker_available');
      break;
    case 'tentative':
      label = t('availability_page.worker_tentative');
      break;
    case 'pending':
      label = t('availability_page.worker_pending');
      break;
    case 'blocked':
      label = t('availability_page.worker_blocked');
      break;
    default:
      throw new Error(`Invalid availability type: ${type}`);
  }

  return (
    <StyledChip
      label={
        <Typography variant="body2" fontWeight={600}>
          {label}
        </Typography>
      }
      size="small"
      sx={{
        backgroundColor: getColorForAvailabilityType(type, 0.2),
      }}
    />
  );
};

const StyledChip = styled(Chip)(({ theme }) => ({
  height: 'auto',
  margin: 0,
  backgroundColor: 'transparent',
  '& .MuiChip-label': {
    whiteSpace: 'normal',
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  },
}));
